<template>
  <div class="page" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="申请加盟" class="user_service_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>

    <van-field v-model="contact" label="姓名" placeholder="请输入姓名" />
    <van-field v-model="phone" type="tel" label="联系电话" placeholder="请输入联系电话" />
    <van-field readonly clickable name="picker" :value="address" label="省市区" placeholder="点击选择所在地" @click="IsShow = true" right-icon="arrow" />
    <p class="foot-tips">*为便于尽快与您取得联系，请填写真实信息。</p>

    <van-button class="foot-btn" size="large" color="#3F7CFF" @click="submit">提交</van-button>

    <van-popup v-model="IsShow" position="bottom">
      <van-area title="所在地" @confirm="onConfirm" @cancel="IsShow = false" :value="districtId" :area-list="areaList" />
    </van-popup>

  </div>
</template> 
  
  <script>
let areaData = require("../../utils/area.js"); //根据需求改成你自己的路径
export default {
  name: "Join-form",
  components: {},
  props: {},
  data() {
    return {
      contact: "",
      phone: Lockr.get("mobile"),
      address: "",
      areaList: areaData.default,
      districtId: "110101",
      IsShow: false,
    };
  },
  watch: {},
  created() {},
  mounted() { 
  },
  methods: {
    onConfirm(value) {
      console.log(value);
      this.address =
        value[0].name + "、" + value[1].name + "、" + value[2].name; //前置地址
      this.IsShow = false;
    },
    submit() {
      var that = this;
      if (!/^1[3456789]\d{9}$/.test(that.phone)) {
        this.$toast.fail("请填写正确的手机号！");
        return;
      }
      if (!that.contact) {
        this.$toast.fail("姓名不可为空！");
        return;
      }
      if (!that.address) {
        this.$toast.fail("所在地不可为空！");
        return;
      }
      // if (repairReason.length < 1) {
      //   this.$toast.fail("请选择报修原因！");
      //   return;
      // }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let formData = new FormData();
      //通过append追加数据
      formData.append("contact", that.contact);
      formData.append("phone", that.phone);
      formData.append("address", that.address);

      let data = {
        contact: that.contact, // 订单id, //
        phone: that.phone, // 订单id, //
        address: that.address, // 订单id, //
      };
      console.log(data);
      this.$postForm("/api/apply_merchant", formData, data).then((res) => {
        console.log(res.data.data);
        if (res.data && res.data.code == 0) {
          // that.$toast.clear(); //关闭弹窗
          that.$toast.success(res.data.message);
          //
          setTimeout(function () {
            that.$router.go(-1);
            // 这里就是处理的事件
          }, 2000);
        } else {
          that.$toast.fail(res.data.message);
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
  
  <style lang="scss">
.user_service_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>
  
  <style lang="scss" scoped>
.page {
  width: 100%;
  padding: 50px 0;
  text-align: left;
  background-color: #f7f7f7;
  h3 {
    text-align: left;
    margin-top: 70px;
    padding-left: 30px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 61px;
    color: #2a2e43;
  }
  .top-tips {
    text-align: left;
    padding-left: 38px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30px;
    color: #999999;
  }
  .centers {
    margin-top: 50px;
    padding: 0 38px;
    .input-tips {
      margin-top: 10px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .input-success {
        display: inline-block;
        width: 18px;
        height: 18px;
        font-size: 18px;
        color: #3f7cff;
      }
    }
    .code-input {
      // margin: 100px 0;
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      border-bottom: solid 1px #cccccc;
      display: flex;
      justify-content: space-between;
      input {
        width: 70%;
        height: 100%;
        text-align: left;
        background: none;
        outline: none;
        border: none;
        font-size: 18px;
      }
      .code-btn {
        width: 80px;
        height: 25px;
        border: 1px solid #999999;
        opacity: 1;
        border-radius: 5px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 21px;
        color: #999999;
      }

      .arr_icon {
        border: 1px solid #3f7cff;
        color: #3f7cff;
      }
    }
  }
  .foot-tips {
    margin: 10px 0 30px 0;
    text-align: left;
    padding-left: 38px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // line-height: 21px;
    color: #999999;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      margin-left: 5px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #1775e6;
    }
  }
}
.foot-btn {
  width: 345px;
  box-sizing: border-box;
  margin: 30px 15px 0;
  border-radius: 10px;
}
</style>
  